module.exports = __webpack_public_path__ + "static/Maestro-c03397177f5756e081d463c0fa372895.svg";